module.exports = __webpack_public_path__ + "assets/img/info-alt.50d66f46.svg";